import { render, staticRenderFns } from "./WrongInfo.vue?vue&type=template&id=62e73c6b&scoped=true"
import script from "./WrongInfo.vue?vue&type=script&lang=js"
export * from "./WrongInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e73c6b",
  null
  
)

export default component.exports